<script setup lang="ts">
import type { ProductInformation } from "~/models/Content/ContentProducts"

defineProps<{
  selectedProduct: ProductInformation
  step: string
  activeStep: string
}>()
</script>

<template>
  <UStep :is-active-step="activeStep === step">
    <template #step>
      {{ step }}
    </template>
    <template #title>
      Prøv produktet
    </template>
    <template #content>
      <UCheckoutCard
        :show-payment="false"
        :selected-product="selectedProduct"
      />
    </template>
  </UStep>
</template>

<style scoped></style>
